

// Send adDynamics to requesting iframes
window.addEventListener('message', function(event) {
    if(event.data.action == 'reqAdDynamics') {

        var sendTimeout;
        // var adDynamics = 'fwd_j4=2&fwd_j5=0&fwd_j5=1&fwd_j5=2&fwd_j5=3'


        var sendAdDynamicsToPlayer = function () {
            console.log('sendAdDynamicsToPlayer');
            var adDynamics = 'fwd_j4=2&fwd_j5=0&fwd_j5=1&fwd_j5=2&fwd_j5=3'

            if(typeof $AC === "object" && typeof $AC.getSXPKeys === "function") {
                adDynamics = $AC.getSXPKeys()
            }

            var msg = {
                action: 'sendAdDynamics',
                adDynamics: adDynamics
            }
            event.source.postMessage(msg, '*')
        }

        var adDynamicsReady = function () {
            console.log('adDynamics ready!');
            clearTimeout(sendTimeout);
            sendAdDynamicsToPlayer();
            window.removeEventListener("AC_player_start", adDynamicsReady);
        }



        if(typeof $AC === "object" && typeof $AC.playerInitReady === "function") {
            if ($AC.playerInitReady()) {
                // Event schon vorbei, Player kann direkt starten.
                // Tritt vor allem im optout-Fall auf.
                console.log('sending final adDynamics!')

                window.removeEventListener("AC_player_start", adDynamicsReady);

                sendAdDynamicsToPlayer()
            } else {
                // Fallback: nach bestimmter Zeit starten.
                // Bspw. 3 Sek. nach Initialisierung der VDC, wobei i.d.R. alle
                // Parameter ca. 500ms nach Initialisierung zur Verfügung stehen

                console.log('adDynamics requested, but not yet ready!')

                window.addEventListener("AC_player_start", adDynamicsReady);

                clearTimeout(sendTimeout);
                sendTimeout = setTimeout(sendAdDynamicsToPlayer, 3000);
            }
        }
        else {
            console.log('no $AC object, delaying adDynamics!')
            clearTimeout(sendTimeout);
            sendTimeout = setTimeout(sendAdDynamicsToPlayer, 3000);
        }


        // try {
        //
        //     if(typeof $AC === "object" && typeof $AC.getSXPKeys === "function") {
        //         adDynamics = $AC.getSXPKeys()
        //     }
        //
        //     // adDynamics = $AC.getSXPKeys() ? $AC.getSXPKeys() : adDynamics
        // }
        // catch(e) {}
        //
        // msg = {
        //     action: 'sendAdDynamics',
        //     adDynamics: adDynamics
        // }
        // event.source.postMessage(msg, '*')


    }
});








// WEBPACK FOOTER //
// ./src/scripts/sendAdDynamics.js